import { toaster } from '@optiaxiom/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useInstanceId } from '@frontend/hooks/useInstanceId';

import { agentExecutionsService } from '../services/agentExecutions';

type UseCancelWorkflowExecutionOptions = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

export function useCancelWorkflowExecution(options?: UseCancelWorkflowExecutionOptions) {
  const { instanceId } = useInstanceId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (executionId: string) =>
      agentExecutionsService.cancelWorkflowExecution(instanceId, executionId),
    onSuccess: () => {
      // Invalidate and refetch execution queries
      queryClient.invalidateQueries({ queryKey: ['agentExecutions'] });
      queryClient.invalidateQueries({ queryKey: ['executionDetails'] });

      toaster.create('Workflow execution cancelled successfully', {
        intent: 'success',
      });

      options?.onSuccess?.();
    },
    onError: (error: Error) => {
      toaster.create('Failed to cancel workflow execution', {
        intent: 'danger',
        description: error.message,
      });

      options?.onError?.(error);
    },
  });
}
